import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import DefaultLayout from "../../components/DefaultLayout";
import {Accordion, List, Checkbox} from 'antd-mobile'
import { createForm } from 'rc-form';

import BottomPanel from "../../components/BottomPanel";
import OrderService from "../../apiServices/OrderService";
import InsuBrandService from "../../apiServices/InsuBrandService";
import {notification} from "antd";

const CheckboxItem = Checkbox.CheckboxItem;

class ChooseInsuBrand extends Component {
    constructor(props){
        super(props);

        const urlParams = new URLSearchParams(window.location.search);
        const object_id = urlParams.get('object_id');

        this.state = {
            height: props.height,
            hasError: false,
            insuBrands: null,
            objectId: object_id,
            order_id: 0,

            hiddenBtn: false,
            insuBrandId: 1,
        };
    }

    componentDidMount() {
        this.setState({height: window.innerHeight + 'px'});

        if (this.state.objectId){
            OrderService.findByObjectId(this.state.objectId).then(response=>{
                this.setState({order_id: response.data.id});
            }).catch(function(error){
                console.log(error);
            });
        }else{
            this.props.history.push('/');
        }
    }

    formSubmit = () => {
        OrderService.updateBrandId({
            'order_id': this.state.order_id,
            'insu_brand_id': this.state.insuBrandId
        }).then(response => {
            this.props.history.push('/thong-tin-nguoi-mua?object_id='+response.data.object_id)
        }).catch(error => {
            notification.error({
                message: JSON.stringify(error),
                description: 'Lỗi lưu thông tin',
            });
        });
    };

    onCbxChange = (insuBrandId) => {
        this.setState({insuBrandId: insuBrandId});
    };

    render() {
        if(this.state.order_id!==0 && this.state.insuBrands==null){
            InsuBrandService.getList(this.state.objectId).then(response => {
                this.setState({insuBrands: response.data});
            }).catch(function(error){
                console.log(error);
            });
        }

        let listBrand = (<div></div>);
        if(this.state.insuBrands!==null) {
            listBrand = this.state.insuBrands.map((item, index) => (
                <Accordion.Panel header={(<CheckboxItem  onChange={() => this.onCbxChange(item.id)} checked={item.id===this.state.insuBrandId} className='cbxBrand' wrap key={index}>
                    <img style={{marginRight: '7px'}} src={require('../../resources/images/logos/insur_brand_'+item.id+'.png')} alt="" />{item.name}
                    <span className='baseFeeShort'>~{item.base_fee_short}</span>
                </CheckboxItem>)}>
                    <List className="my-list">
                        <List.Item extra={Number(item.base_fee).toLocaleString('en')+' đ'}>Phí cơ bản</List.Item>
                        <List.Item extra={'Miễn phí'}>BS02 BH thay thế mới</List.Item>
                        <List.Item extra={Number(item.add_fee_04).toLocaleString('en')+' đ'}>BS04 BH Xe bị mất trộm, cướp bộ phận</List.Item>
                        <List.Item extra={Number(item.add_fee_05).toLocaleString('en')+' đ'}>BS05 Lựa chọn cơ sở sửa chữa</List.Item>
                        <List.Item extra={'Miễn phí'}>BS06 BH động cơ do thủy kích</List.Item>
                        <List.Item extra={Number(item.add_fee_13).toLocaleString('en')+' đ'}>BS13 BH thiết bị lắp thêm</List.Item>
                    </List>
                </Accordion.Panel>
            ));
        }

        return (
            <div className='App-block bgWhite' style={{minHeight: this.state.height}}>
                <DefaultLayout {...this.props} showHome={true} title="Chọn hãng bảo hiểm" classNameContent="bgWhite" page_type={1} hiddenFt={true} showBottomPanel={true}>
                    <div className="wrap-content">
                        <Accordion accordion defaultActiveKey="0" className="brand-accordion" onChange={this.onChange}>
                            {listBrand}
                        </Accordion>

                    </div>
                </DefaultLayout>
                <BottomPanel handleClick={this.formSubmit} hidden={this.state.hiddenBtn} title={"Mua ngay"} actionType='submit' actionContent={'thong-tin-nguoi-mua'}/>
            </div>
        )
    }
}

ChooseInsuBrand = createForm()(ChooseInsuBrand);

export default (withTranslation())(ChooseInsuBrand);